import {useEffect} from 'react';
import {checkIfTextEntryTarget} from '../../utils/dom/checkIfTextEntryTarget';

/**
 * Модалка на весь экран забирает клавиатуру у поля ввода, которое она
 * накрыла. Фокус мог остаться, например, в поле чата матча: его Enter и пробел
 * уходили бы в спрятанный под модалкой черновик (поле останавливает всплытие
 * нажатий — см. ChatPanel), а модалка не закрывалась бы клавишами, как
 * задумано (useCloseOnEnterSpace).
 *
 * Поле внутри самой модалки (containerRef) не трогаем: его автофокус
 * срабатывает раньше эффектов родителя.
 */
export const useBlurCoveredTextEntry = (containerRef) => {
  useEffect(() => {
    const active = typeof document === 'undefined' ? null : document.activeElement;
    if (!checkIfTextEntryTarget(active)) {
      return;
    }
    if (containerRef?.current && containerRef.current.contains(active)) {
      return;
    }
    active.blur();
    // Только в момент появления модалки: поле, выбранное уже поверх нее,
    // игрок выбрал сам
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
